/**
 * Created by Jerker Nord on 2019-03-11.
 * Quick and dirty Typescript version of
 * https://github.com/thibauts/cubic-hermite-spline
 */

export class CubicHermiteSpline {

    public static interpolate(t:number, points:number[][], tangents:number[][], knots?:number[], derivative:boolean = false, result?:number[]) {

        const n:number = points.length;    // number or points / tangents / knots
        const d:number = points[0].length; // vector dimensionality
        const v:number | number[] = result || [d]; // destination vector
        let i0:number;
        let i1:number;
        let scale:number;

        if(knots) {
            // find knot interval for t
            let i:number;
            for(i = 0; i < n - 1; i++) {
                if(t >= knots[i] && t <= knots[i + 1]) {
                    break;
                }
            }

            if(i === n - 1) throw new Error('out of bounds');

            i0 = i;
            i1 = i + 1;
            const k0:number = knots[i0];
            const k1:number = knots[i1];
            scale = k1 - k0;

            t = (t - k0) / scale;

        } else {

            const tRescaled:number = t * (n - 1); // rescale t to [0, n-1]
            i0 = tRescaled | 0;        // truncate
            i1 = i0 + 1;

            if(i0 > n - 1) throw new Error('out of bounds');
            if(i0 === n - 1) i1 = i0;

            scale = i1 - i0;

            t = (tRescaled - i0) / scale;
        }

        let t2:number;
        let h00:number;
        let h10:number;
        let h01:number;
        let h11:number;
        if(derivative) {
            t2 = t * t;
            h00 = 6 * t2 - 6 * t;
            h10 = 3 * t2 - 4 * t + 1;
            h01 = -6 * t2 + 6 * t;
            h11 = 3 * t2 - 2 * t;
        } else {
            t2 = t * t;
            const it:number = 1 - t;
            const it2:number = it * it;
            const tt:number = 2 * t;
            h00 = (1 + tt) * it2;
            h10 = t * it2;
            h01 = t2 * (3 - tt);
            h11 = t2 * (t - 1);
        }

        for(let i:number = 0; i < d; i++) {
            v[i] = h00 * points[i0][i] +
                h10 * tangents[i0][i] * scale +
                h01 * points[i1][i] +
                h11 * tangents[i1][i] * scale;
        }

        return v;
    }
}